<template>
  <div class="main-preview">
    <div class="mask" v-if="liveDetail.status !== LIVE_STATUS.ING">
      <div class="empty-tip">
        <i class="icon-img"></i>
        <p class="tip">{{ liveStatusTip[liveDetail.status] }}</p>
      </div>
    </div>
    <!-- 布局start -->
    <div v-if="previewLayout.type === 'full_screen'" class="preview-wrap">
      <div class="full-screen-item item-bg" draggable="false">
        <div
          class="stream-container"
          v-if="previewPanelList[0]"
          draggable="false"
          :data-streamId="previewPanelList[0].streamId"
        >
          <!-- {{ previewPanelList[0].streamId }} -->
          <video autoplay muted id="previewPanelList0FullScreen"></video>
        </div>
      </div>
    </div>
    <div v-if="previewLayout.type === 'sidebar'" class="preview-wrap sidebar">
      <div
        :class="`sidebar-left item-bg ${allowDropIndex === 0 || dragIndex === 0 ? 'active' : ''}`"
        :draggable="previewPanelList.length > 1"
        @dragstart.stop="drag(0)"
        @dragover.prevent="allowDrop(0)"
        @drop.stop="drop(0)"
      >
        <div class="stream-container" v-if="previewPanelList[0]" :data-streamId="previewPanelList[0].streamId">
          <!-- {{ previewPanelList[0].streamId }} -->
          <video autoplay muted id="previewPanelList0Sidebar"></video>
        </div>
      </div>
      <div class="sidebar-right">
        <div class="sidebar-right-container">
          <div
            :class="`sidebar-item item-bg ${allowDropIndex === 1 || dragIndex === 1 ? 'active' : ''}`"
            :draggable="previewPanelList.length > 1"
            @dragstart.stop="drag(1)"
            @dragover.prevent="allowDrop(1)"
            @drop.stop="drop(1)"
          >
            <div class="stream-container" v-if="previewPanelList[1]" :data-streamId="previewPanelList[1].streamId">
              <!-- {{ previewPanelList[1].streamId }} -->
              <video autoplay muted id="previewPanelList1Sidebar"></video>
            </div>
          </div>
          <div
            :class="`sidebar-item item-bg ${allowDropIndex === 1 || dragIndex === 1 ? 'active' : ''}`"
            v-if="previewPanelList[2]"
            draggable="true"
            @dragstart.stop="drag(2)"
            @dragover.prevent="allowDrop(2)"
            @drop.stop="drop(2)"
          >
            <div class="stream-container" :data-streamId="previewPanelList[2].streamId">
              <!-- {{ previewPanelList[2].streamId }} -->
              <video autoplay muted id="previewPanelList2Sidebar"></video>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="previewLayout.type === 'float'" class="preview-wrap">
      <div
        :class="`float-big-item item-bg ${allowDropIndex === 0 || dragIndex === 0 ? 'active' : ''}`"
        :draggable="false"
        @dragstart="drag(0)"
        @dragover.prevent="allowDrop(0)"
        @drop="drop(0)"
      >
        <div
          class="stream-container"
          v-if="previewPanelList[0]"
          :draggable="false"
          :data-streamId="previewPanelList[0].streamId"
        >
          <!-- {{ previewPanelList[0].streamId }} -->
          <video autoplay muted id="previewPanelList0Float"></video>
        </div>
      </div>
      <div
        :class="`float-item ${allowDropIndex === 1 || dragIndex === 1 ? 'active' : ''}`"
        :draggable="previewPanelList.length > 1"
        @dragstart="drag(1)"
        @dragover.prevent="allowDrop(1)"
        @drop="drop(1)"
      >
        <div class="stream-container" v-if="previewPanelList[1]" :data-streamId="previewPanelList[1].streamId">
          <!-- {{ previewPanelList[1].streamId }} -->
          <video autoplay muted id="previewPanelList1Float"></video>
        </div>
      </div>
    </div>
    <div v-if="previewLayout.type === 'grid'" class="preview-wrap grid">
      <div class="grid-row">
        <div
          :class="`grid-item item-bg ${allowDropIndex === 0 || dragIndex === 0 ? 'active' : ''}`"
          :draggable="previewPanelList.length > 1"
          @dragstart="drag(0)"
          @dragover.prevent="allowDrop(0)"
          @drop="drop(0)"
        >
          <div class="stream-container" v-if="previewPanelList[0]" :data-streamId="previewPanelList[0].streamId">
            <!-- {{ previewPanelList[0].streamId }} -->
            <video autoplay muted id="previewPanelList0Grid"></video>
          </div>
        </div>
        <div
          :class="`grid-item item-bg ${allowDropIndex === 1 || dragIndex === 1 ? 'active' : ''}`"
          :draggable="previewPanelList.length > 1"
          @dragstart="drag(1)"
          @dragover.prevent="allowDrop(1)"
          @drop="drop(1)"
        >
          <div class="stream-container" v-if="previewPanelList[1]" :data-streamId="previewPanelList[1].streamId">
            <!-- {{ previewPanelList[1].streamId }} -->
            <video autoplay muted id="previewPanelList1Grid"></video>
          </div>
        </div>
      </div>
      <div class="grid-row" v-if="previewPanelList[2] || previewPanelList[3]">
        <div
          :class="`grid-item item-bg ${allowDropIndex === 2 || dragIndex === 2 ? 'active' : ''}`"
          v-if="previewPanelList[2]"
          draggable="true"
          @dragstart="drag(2)"
          @dragover.prevent="allowDrop(2)"
          @drop="drop(2)"
        >
          <div class="stream-container" :data-streamId="previewPanelList[2].streamId">
            <!-- {{ previewPanelList[2].streamId }} -->
            <video autoplay muted id="previewPanelList2Grid"></video>
          </div>
        </div>
        <div
          :class="`grid-item item-bg ${allowDropIndex === 3 || dragIndex === 3 ? 'active' : ''}`"
          v-if="previewPanelList[3]"
          draggable="true"
          @dragstart="drag(3)"
          @dragover.prevent="allowDrop(3)"
          @drop="drop(3)"
        >
          <div class="stream-container" :data-streamId="previewPanelList[3].streamId">
            <!-- {{ previewPanelList[3].streamId }} -->
            <video autoplay muted id="previewPanelList3Grid"></video>
          </div>
        </div>
      </div>
    </div>
    <div v-if="previewLayout.type === 'intelligent_following'" class="preview-wrap ai-follow">
      <div class="ai-left item-bg">
        <div class="stream-container stream-container-cut">
          <!-- {{ speakerTeacherDevicePanel.streamId }} -->
          <div
            class="stream-container-cut-inner"
            v-if="speakerTeacherDevicePanel.streamId"
            :data-streamId="speakerTeacherDevicePanel.streamId"
          >
            <video autoplay muted id="speakerTeacherDevicePanelIntelligentFollowing"></video>
          </div>
        </div>
      </div>
      <div class="ai-right item-bg">
        <div
          class="stream-container"
          v-if="(previewPanelListTemp[0] || {}).streamId"
          :data-streamId="(previewPanelListTemp[0] || {}).streamId"
        >
          <!-- {{ (previewPanelListTemp[0] || {}).streamId }} -->
          <video autoplay muted id="previewPanelListTemp0IntelligentFollowing"></video>
        </div>
      </div>
    </div>
    <!-- 布局end -->

    <div class="btn-list" v-if="liveDetail.status === LIVE_STATUS.ING && isPreviewing">
      <a-button @click="cancelLayoutChange">取消</a-button>
      <a-button
        type="primary"
        :loading="applyLoading"
        :disabled="isApplyDisabled"
        @click="applyLayout({ autoCaster: false, isPreviewing: false })"
      >
        应用
      </a-button>
    </div>
  </div>
</template>

<script>
import { layoutChange } from '@/server/api/guideStation'
import { checkRes } from '@/utils/tool'
import { DEVICE_ROLE } from '@/consts/camera'
import { ROLE } from '@/consts/user'
import { LIVE_STATUS } from '@/consts/live'

export default {
  name: 'MainPreview', // 手工导播
  props: {
    liveId: String | Number,
    isPreviewing: Boolean, // 是否有手工操作
    previewLayout: {
      type: Object,
      default() {
        return {}
      }
    },
    previewPanelList: {
      type: Array,
      default() {
        return []
      }
    },
    delLayoutChangeStream: {
      type: Object,
      default() {
        return {}
      }
    },
    liveDetail: {
      type: Object,
      default() {
        return {}
      }
    },
    streamMap: {
      type: Map,
      default: new Map()
    },
    layoutChangeMsg: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  components: {},
  computed: {
    videoId: function () {
      // const videoStreamId = this.previewPanelList[0].streamId
      // const res = this.streamMap.get(videoStreamId)

      console.log(this.previewPanelList[0], 'res_res_res')
      return '111'
    }
  },
  data() {
    return {
      applyLoading: false, // 应用按钮loading
      LIVE_STATUS,
      DEVICE_ROLE,
      dragIndex: null, // 拖拽的预览card
      allowDropIndex: null,
      dropIndex: null, //
      layoutInfo: {},
      liveStatusTip: {
        0: '课堂未开始',
        1: '课堂进行中',
        2: '课堂已结束'
      },
      speakerTeacherDevicePanel: {}, // 主讲老师机位预览流对象
      previewPanelListTemp: [], // 去除speakerTeacherDevicePanel后的预览流列表
      isApplyDisabled: true, // 应用按钮状态
      oldApplyParams: {}, // 应用布局老参数，用于参数对比
      newApplyParams: {} // 应用布局新参数
    }
  },
  watch: {
    previewLayout: {
      handler() {
        this.canApply()
        this.$emit('operationDOM')
      },
      deep: true
    },
    layoutChangeMsg: {
      handler(nVal, oVal) {
        this.oldApplyParams = this.getApplyParams()
        this.$emit('operationDOM')
      },
      deep: true
    },
    previewPanelList: {
      handler(nVal, oVal) {
        // 为布局5做特别处理，分离出教师机位
        this.previewPanelListTemp = [...nVal]
        const targetIndex = nVal.findIndex((i) => i.role === ROLE.SPEAKER && i.deviceRole === DEVICE_ROLE.TEACHER)
        if (targetIndex >= 0) {
          this.speakerTeacherDevicePanel = nVal[targetIndex]
          this.previewPanelListTemp.splice(targetIndex, 1)
        } else {
          this.speakerTeacherDevicePanel = {}
        }
        this.canApply()
        this.$emit(
          'getSpeakerTeacherDevicePanelAndPreviewPanelListTemp',
          this.speakerTeacherDevicePanel,
          this.previewPanelListTemp
        )
      },
      deep: true
    },
    delLayoutChangeStream: {
      handler(nVal) {
        // 重新应用
        this.applyLayout({
          autoCaster: this.liveDetail.autoCaster,
          isPreviewing: this.isPreviewing
        })
      },
      deep: true
    }
  },
  methods: {
    // 取消预览布局
    async cancelLayoutChange() {
      this.$emit('cancelLayoutChange')
    },
    // 应用按钮是否可以点击
    canApply() {
      const { previewLayout, previewPanelList, oldApplyParams } = this
      if (!Object.keys(previewLayout).length) return
      this.newApplyParams = this.getApplyParams()
      const existDiffPanel = (oldApplyParams.panels || []).find(
        (item, index) => item.streamId !== (previewPanelList[index] || {}).streamId
      ) // 是否存在不同的streamId
      console.log(2181, 'existDiffPanel', existDiffPanel, previewPanelList)
      console.log(2181, 'old', this.oldApplyParams.panels)
      console.log(2181, 'new', this.newApplyParams.panels)
      if (
        !this.newApplyParams.casterMode ||
        previewPanelList.length < previewLayout.layoutParams[0].panels.length ||
        (oldApplyParams.casterMode === this.newApplyParams.casterMode &&
          oldApplyParams.layout === this.newApplyParams.layout &&
          !existDiffPanel)
      ) {
        this.isApplyDisabled = true
      } else {
        this.isApplyDisabled = false
      }
    },
    // 获取应用布局参数
    getApplyParams() {
      const self = this
      const { previewLayout, previewPanelList, speakerTeacherDevicePanel, previewPanelListTemp } = self
      const lastPanelParams = previewLayout.layoutParams[previewLayout.layoutParams.length - 1]
      const targetLayoutParams =
        previewLayout.layoutParams.find((i) => i.panels.length === previewPanelList.length) || lastPanelParams
      const newPreviewPanelList =
        previewLayout.type === 'intelligent_following'
          ? [speakerTeacherDevicePanel, ...previewPanelListTemp]
          : previewPanelList // 布局5的预览列表针对老师机位有变动
      return {
        liveId: this.liveId,
        casterMode: previewLayout.type,
        layout: targetLayoutParams.layout,
        panels: targetLayoutParams.panels.map((item, index) => ({
          name: item.name,
          streamId: (newPreviewPanelList[index] || {}).streamId
        })),
        autoCaster: false,
        requestFrom: 'admin'
      }
    },
    // 应用布局
    async applyLayout({ autoCaster, isPreviewing }) {
      const self = this
      self.applyLoading = true
      const res = await layoutChange({ ...this.newApplyParams, autoCaster })
      checkRes({
        res,
        success() {
          self.$message.success('应用成功！')
        },
        failed() {
          self.$message.error('应用布局失败！')
        }
      })
      self.applyLoading = false
      this.$emit('changeIsPreviewing', isPreviewing)
      this.$emit('operationDOM')
    },
    drag(index) {
      this.dragIndex = index
    },
    allowDrop(index) {
      this.allowDropIndex = index
    },
    drop(index) {
      this.dropIndex = index
      const dragPanel = this.previewPanelList[this.dragIndex]
      const dropPanel = this.previewPanelList[this.dropIndex]
      const newArr = [...this.previewPanelList]

      newArr.splice(this.dragIndex, 1, dropPanel)
      newArr.splice(this.dropIndex, 1, dragPanel)
      this.dragIndex = null
      this.allowDropIndex = null
      this.dropIndex = null
      this.$emit('updateCardList', newArr)
      this.$emit('operationDOM')
    }
  }
}
</script>

<style lang="scss" scoped>
.main-preview {
  position: relative;
  width: 100%;
  height: 100%;
  background: #d9dfe5;
  .mask {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 9;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 0.4rem;
    background-color: rgba(0, 0, 0, 0.1);
    .icon-img {
      display: block;
      width: 10rem;
      height: 10rem;
      background-image: url('~@/assets/img/guideStation/empty-box@2x.png');
      background-repeat: no-repeat;
      background-size: cover;
    }
    .tip {
      font-size: 1.6rem;
      color: #1e2228;
      padding-top: 1rem;
    }
  }
  .btn-list {
    position: absolute;
    right: 1.6rem;
    bottom: 1.6rem;
    .ant-btn {
      margin-left: 1.6rem;
    }
  }

  .preview-wrap {
    width: 100%;
    height: 100%;
    .item-bg {
      position: relative;
      background: rgba(22, 114, 255, 0.2);
      border: 0.2rem solid #d9dfe5;
      &.active {
        border-color: #00cf96;
      }
    }
    .stream-container {
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;

      overflow: hidden;
      video {
        // width: auto;
        width: 100%;
        height: 100%;
        background-color: #000;
      }
      &.stream-container-cut {
        width: 100%;
        height: 100%;
        overflow: hidden;
        .stream-container-cut-inner {
          width: auto;
          height: 100%;
          video {
            width: auto;
            height: 100%;
            position: absolute;
            left: 50%;
            top: 0;
            transform: translateX(-50%);
          }
        }
      }
    }
    // 布局1
    .full-screen-item,
    .float-big-item {
      width: 100%;
      height: 100%;
    }
    // 布局2
    &.sidebar {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .sidebar-left {
      width: 67%;
      padding-top: 37.4%; //36.25%;//36.56%; // 56.25% * 65%
    }

    .sidebar-right {
      width: 33%;
      padding-top: 37.6%; // 36.56%
      position: relative;
      .sidebar-right-container {
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        .sidebar-item {
          width: 100%;
          height: 50%;
        }
      }
    }
    // 布局3
    .float-item {
      width: 20%;
      padding-top: 11%; //11.25%; // 55.25% * 20%
      background: #fff;
      position: absolute;
      top: 1.6rem;
      right: 1.6rem;
      border: 0.2rem solid #fff;
      border-radius: 0.4rem;
      &.active {
        border-color: #00cf96;
      }
    }
    // 布局4
    &.grid {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      align-items: center;
      .grid-row {
        width: 100%;
        height: 50%;
        display: flex;
        justify-content: center;
        .grid-item {
          width: 50%;
          height: 100%;
        }
      }
    }

    // 布局5,智能跟随
    &.ai-follow {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      .ai-left {
        width: 20%;
        padding-top: 44.5%;
      }
      .ai-right {
        width: 80%;
        padding-top: 44.6%; // 56.25% * 80%
      }
    }
  }
}
</style>
